import React from 'react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-mover-darkest bg-opacity-50 backdrop-blur-md text-mover-light py-4 sm:py-6 px-4">
      <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center">
        <div className="mb-4 sm:mb-0 text-center sm:text-left">
          <p className="text-sm sm:text-base">&copy; 2024 Mover Marketing AI. All rights reserved.</p>
          <a href="https://www.movermarketing.ai?utm_source=online&utm_medium=seoaudit&utm_campaign=seoaudit&utm_id=seoaudit" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base hover:text-mover-cyan transition-colors duration-300">
            www.movermarketing.ai
          </a>
        </div>
        <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
          <a href="https://www.movermarketing.ai/legal/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base hover:text-mover-cyan transition-colors duration-300">
            Terms of Service
          </a>
          <a href="https://www.movermarketing.ai/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base hover:text-mover-cyan transition-colors duration-300">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer